/**
 * @class ProductDetails
 * @classdesc A minimal version of the product, limiting details only to the necessary elements.
 *
 * @extends Core.Component
 */
export default class ProductDetails extends Core.Component {
  onMount() {
    const viewFullDetailsLink = this.query('button-link');

    this.events.register(viewFullDetailsLink.el, 'click', e => {
      const clickEvent = new CustomEvent('product-details:view-full-details', { bubbles: true, cancelable: true });
      const isCancelled = !viewFullDetailsLink.el.dispatchEvent(clickEvent);

      if (isCancelled) {
        e.stopPropagation();
        e.preventDefault();
      }
    });
  }

  onDismount() {
    this.events.unregisterAll();
  }
}
